import React from 'react';
import { useTranslations } from 'next-intl';
import styled from 'styled-components';

import Headline from '@components/atoms/headline/headline';
import Copy from '@components/atoms/copy/copy';

import Card from './Card';

const StyledErrorCard = styled(Card)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  p {
    margin: 0;
  }
`;

const ErrorCard = () => {
  const t = useTranslations();
  return (
    <StyledErrorCard>
      <Headline>{t('archive.errorHeadline')}</Headline>
      <Copy small>{t('archive.errorCopy')}</Copy>
    </StyledErrorCard>
  );
};

export default ErrorCard;
